import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import Message from "../../../../i18n/Message";
import React, { useState } from "react";
import MarkdownContainer from "../../../shared/markdown/MarkdownContainer";

const ExampleToolUseBlock = ({ block, messageIdx, messages }) => {
  const [expanded, setExpanded] = useState(false);

  const responseBlock = messages[messageIdx + 1]?.content?.find((item) => {
    return item.type === "tool_result" && item.tool_use_id === block.id;
  });

  // Live MCP tool args can be objects/arrays — render them as text, never as a
  // raw React child (which would throw "Objects are not valid as a React child").
  const renderValue = (v) =>
    v !== null && typeof v === "object" ? JSON.stringify(v) : String(v);

  return (
    <div
      className="tool_use_block_container"
      onClick={() => setExpanded(!expanded)}
    >
      <div className="tool_use_block_header">
        <div className="tool_use_block_name">
          <Message id="widget_use_tool_prefix" />
          <div className="tool_name_badge">{block.name}</div>
        </div>
        <div className="tool_use_right_side">
          {expanded && <ChevronUpIcon size={18} />}
          {!expanded && <ChevronDownIcon size={18} />}
        </div>
      </div>

      {expanded && (
        <div className="tool_use_block_body">
          {block.input && Object.keys(block.input).length > 0 && (
            <div className="params_table grid_table">
              <div className="table_header">
                <Message id="widget_tool_use_param" />
              </div>
              <div className="table_header">
                <Message id="widget_tool_use_value" />
              </div>
              {Object.keys(block.input).map((paramName) => {
                return (
                  <React.Fragment key={paramName}>
                    <div className="param_name table_cell name">
                      {paramName}
                    </div>
                    <div className="param_value table_cell description">
                      {renderValue(block.input[paramName])}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          )}
          <div className="tool_use_response_body">
            {!responseBlock && <Message id="widget_tool_use_no_response" />}
            {responseBlock && (
              <>
                <div className="tool_use_response_title">
                  <Message id="widget_tool_use_response_title" />
                </div>
                <div className="tool_use_response_content">
                  <MarkdownContainer>{responseBlock.content}</MarkdownContainer>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ExampleToolUseBlock;
